module.exports = __webpack_public_path__ + "img/cb3p-r-yr1.ff05ff5d.gif";